import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _extends from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getFallback, getSrc, isWebp } from '@anm/helpers/image';
import { useCallback, useEffect, useState } from 'react';

var RegularImage = function RegularImage(_ref) {
  var imageRef = _ref.imageRef,
      otherProps = _objectWithoutProperties(_ref, ["imageRef"]);

  return __jsx("img", _extends({
    ref: imageRef
  }, otherProps));
};

var WebpImage = function WebpImage(_ref2) {
  var imgSource = _ref2.src,
      imageRef = _ref2.imageRef,
      otherProps = _objectWithoutProperties(_ref2, ["src", "imageRef"]);

  return __jsx("picture", null, __jsx("source", {
    type: "image/webp",
    srcSet: imgSource
  }), __jsx("img", _extends({
    ref: imageRef,
    src: getFallback(imgSource)
  }, otherProps)));
};

var Image = function Image(_ref3) {
  var src = _ref3.src,
      _ref3$draggable = _ref3.draggable,
      draggable = _ref3$draggable === void 0 ? true : _ref3$draggable,
      otherProps = _objectWithoutProperties(_ref3, ["src", "draggable"]);

  var _useState = useState(getSrc(src)),
      imgSource = _useState[0],
      setImgSource = _useState[1];

  var handleError = useCallback(function () {
    if (!src) return;
    setImgSource(getSrc(src));
  }, [src]);
  useEffect(function () {
    setImgSource(getSrc(src));
  }, [src]);
  return __jsx(React.Fragment, null, isWebp(src) ? __jsx(WebpImage, _extends({
    src: imgSource
  }, _objectSpread({
    draggable: draggable
  }, otherProps))) : __jsx(RegularImage, _extends({
    src: imgSource,
    onError: handleError
  }, _objectSpread({
    draggable: draggable
  }, otherProps))));
};

export default Image;